import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { AccessTokenQueryKey } from './queryKey';
export const useGetScopes = () => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([AccessTokenQueryKey.GetScopes], () => api.base
        .get(`${config.appUrls.identity}/api/profile/pats/scopes`)
        .then(res => res.data), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
